package org.hs_soft.runmynesto.domain.model.home.statistic.tabs.abc_statics

import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class ABCStatisticGroupByEnum(
    val title: String,
    val value: String
) {
    ARTICLE(
        title = LanguageManager.getCurrentStrings().product,
        value = "product"
    ),
    BRANCH_ARTICLE(
        title = LanguageManager.getCurrentStrings().shopProduct,
        value = "shopProduct"
    ),
    ARTICLE_BRANCH(
        title = LanguageManager.getCurrentStrings().productShop,
        value = "productShop"
    ),
    DATE_ARTICLE(
        title = LanguageManager.getCurrentStrings().dateProduct,
        value = "dateProduct"
    ),
    ARTICLE_DATE(
        title = LanguageManager.getCurrentStrings().productDate,
        value = "productDate"
    ),
    ARTICLE_DATE_BRANCH(
        title = LanguageManager.getCurrentStrings().productDateShop,
        value = "productDateShop"
    )
}